(() => {

  const sliders = qsa('.js-review-carousel__swiper');

  Array.prototype.forEach.call(sliders, function(slide) {
    new Swiper(slide, {
      init: true,
      spaceBetween: 15,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

 
})();
